export const PENDING_PAYMENT_MESSAGE = "Payment has not been completed yet.";

export type FinalizeErrorKind = "pending" | "forbidden" | "error";

export interface FinalizeErrorShape {
	status?: number;
	data?: { message?: string };
}

export const classifyFinalizeError = (err: unknown): FinalizeErrorKind => {
	const error = err as FinalizeErrorShape;

	if (error?.status === 400 && error?.data?.message === PENDING_PAYMENT_MESSAGE) {
		return "pending";
	}

	if (error?.status === 403) {
		return "forbidden";
	}

	return "error";
};
